import { AppLanguage, getPreferredLanguage } from '../language';

export interface AccountI18nTemplate {
  ui: {
    actionMyWallet: string;
    actionLoginNow: string;
    accountLandingDescription: string;
    balanceTitleDeficit: string;
    balanceTitleLow: string;
    balanceTitleHealthy: string;
    actionDownloadTransactions: string;
    actionRecharge: string;
    popupCopySuccess: string;
    popupCopyFailed: string;
    transactionTypeAll: string;
    transactionTypeDeposit: string;
    transactionTypeWithdraw: string;
    transactionTypePay: string;
    transactionTypeRefund: string;
    transactionTypePriceAdjustment: string;
    dateRangePlaceholder: string;
    transactionTypePlaceholder: string;
    transactionSearchPlaceholder: string;
    actionCopyTrackingNumber: string;
    actionCopyTransactionId: string;
    csvHeaderTransactionId: string;
    csvHeaderOrderId: string;
    csvHeaderTrackingNumber: string;
    csvHeaderBillingType: string;
    csvHeaderAmount: string;
    csvHeaderCurrency: string;
    csvHeaderCreatedAt: string;
    csvFilenamePrefix: string;
    transactionDrawerTitle: string;
    transactionDrawerFieldBillingType: string;
    transactionDrawerFieldTime: string;
    transactionDrawerFieldRecipient: string;
    transactionDrawerFieldTrackingNumber: string;
    transactionDrawerFieldTransactionId: string;
    transactionStatusCompleted: string;
    transactionStatusPending: string;
    transactionStatusFailed: string;
    transactionStatusRefunded: string;
  };
}

export const TEMPLATES: Record<AppLanguage, AccountI18nTemplate> = {
  zh: {
    ui: {
      actionMyWallet: '我的钱包',
      actionLoginNow: '立即登录',
      accountLandingDescription: '查看账户余额，管理充值与账单。联系客服获取充值支持。',
      balanceTitleDeficit: '欠费',
      balanceTitleLow: '余额紧张',
      balanceTitleHealthy: '余额充足',
      actionDownloadTransactions: '下载流水',
      actionRecharge: '充值',
      popupCopySuccess: '复制成功',
      popupCopyFailed: '复制失败',
      transactionTypeAll: '全部类型',
      transactionTypeDeposit: '在线充值',
      transactionTypeWithdraw: '提现',
      transactionTypePay: '海外快递',
      transactionTypeRefund: '海外快递退款',
      transactionTypePriceAdjustment: '海外快递价格调整',
      dateRangePlaceholder: '选择日期范围',
      transactionTypePlaceholder: '选择账单类型',
      transactionSearchPlaceholder: '搜索运单号或交易流水号',
      actionCopyTrackingNumber: '复制运单号',
      actionCopyTransactionId: '复制交易流水号',
      csvHeaderTransactionId: '交易ID',
      csvHeaderOrderId: '订单号',
      csvHeaderTrackingNumber: '运单号',
      csvHeaderBillingType: '账单类型',
      csvHeaderAmount: '金额',
      csvHeaderCurrency: '货币',
      csvHeaderCreatedAt: '创建时间',
      csvFilenamePrefix: 'SSEEAA_账单',
      transactionDrawerTitle: '账单详情',
      transactionDrawerFieldBillingType: '账单类型',
      transactionDrawerFieldTime: '交易时间',
      transactionDrawerFieldRecipient: '收件人',
      transactionDrawerFieldTrackingNumber: '运单号',
      transactionDrawerFieldTransactionId: '交易流水号',
      transactionStatusCompleted: '已完成',
      transactionStatusPending: '待处理',
      transactionStatusFailed: '失败',
      transactionStatusRefunded: '已退款',
    },
  },
  en: {
    ui: {
      actionMyWallet: 'My wallet',
      actionLoginNow: 'Log in now',
      accountLandingDescription: 'Check your balance, manage top-ups, and view billing history.',
      balanceTitleDeficit: 'Overdue',
      balanceTitleLow: 'Low balance',
      balanceTitleHealthy: 'Sufficient balance',
      actionDownloadTransactions: 'Download statements',
      actionRecharge: 'Deposit',
      popupCopySuccess: 'Copied',
      popupCopyFailed: 'Copy failed',
      transactionTypeAll: 'All types',
      transactionTypeDeposit: 'Deposit',
      transactionTypeWithdraw: 'Withdraw',
      transactionTypePay: 'Last mile shipping',
      transactionTypeRefund: 'Last mile shipping refund',
      transactionTypePriceAdjustment: 'Last mile shipping adjustment',
      dateRangePlaceholder: 'Select date range',
      transactionTypePlaceholder: 'Select billing type',
      transactionSearchPlaceholder: 'Search tracking number or transaction ID',
      actionCopyTrackingNumber: 'Copy tracking number',
      actionCopyTransactionId: 'Copy transaction ID',
      csvHeaderTransactionId: 'Transaction ID',
      csvHeaderOrderId: 'Order ID',
      csvHeaderTrackingNumber: 'Tracking number',
      csvHeaderBillingType: 'Billing type',
      csvHeaderAmount: 'Amount',
      csvHeaderCurrency: 'Currency',
      csvHeaderCreatedAt: 'Created at',
      csvFilenamePrefix: 'SSEEAA_Bills',
      transactionDrawerTitle: 'Billing details',
      transactionDrawerFieldBillingType: 'Billing type',
      transactionDrawerFieldTime: 'Transaction time',
      transactionDrawerFieldRecipient: 'Recipient',
      transactionDrawerFieldTrackingNumber: 'Tracking number',
      transactionDrawerFieldTransactionId: 'Transaction ID',
      transactionStatusCompleted: 'Completed',
      transactionStatusPending: 'Pending',
      transactionStatusFailed: 'Failed',
      transactionStatusRefunded: 'Refunded',
    },
  },
};

export const ACCOUNT_NAMESPACE = 'account';

export const ACCOUNT_RESOURCE_KEY = 'template';

export const ACCOUNT_I18N_RESOURCES: Record<
  AppLanguage,
  Record<typeof ACCOUNT_RESOURCE_KEY, AccountI18nTemplate>
> = {
  zh: {
    [ACCOUNT_RESOURCE_KEY]: TEMPLATES.zh,
  },
  en: {
    [ACCOUNT_RESOURCE_KEY]: TEMPLATES.en,
  },
};

export const getAccountTemplate = (
  language: AppLanguage = getPreferredLanguage(),
): AccountI18nTemplate => TEMPLATES[language] || TEMPLATES.zh;
